// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__j0ouY","notes":"Notes_notes__1Zf3X","note":"Notes_note__2lV8G","markdown":"Notes_markdown__3XV5t"};